<template>
  <div id="app">
    <router-view />
    <div class="float" v-if="show">
      <a href="/query/#/form">
        <img src="./assets/message2.png" alt />
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "App",
  components: {},
  computed: mapState({
    show: (state) => state.show_float,
  }),
};
</script>

<style lang="scss">
html,
body {
  margin: 0px;
  padding: 0;
}
.header {
  height: 15px;
  background-color:  #407cca;
  display: flex;
  .left {
    flex: 1 0 62.4%;
  }
  .right {
    flex: 1 0 37.6%;
    background-color: #ccc;
  }
}
.footer {
  // border-bottom: 15px solid #686767;
  position: relative;
  bottom: 0;
  // background-color: #284d46;
  img {
    width: 100%;
  }
  .top {
    height: 10px;
    background: url(./assets/main/footer_bg.png) repeat-x;
    background-size: 15%;
  }
  .content {
    display: flex;
    margin: 30px 6%;
    .qr {
      flex: 0 1 30%;
      margin-right: 10px;
      img {
        width: 120px;
      }
    }
    .info {
      flex: 1 0 70%;
      font-size: 10px;
      text-align: left;
      padding-left: 10px;
      // margin-top: 3px;
      box-sizing: border-box;
      h5 {
        font-size: 11px;
        color: #1d4f48;
      }
      p {
        line-height: 20px;
        margin-bottom: 0;
      }
    }
  }
}
.submit {
  background-color: #1d4f48;
}
.float {
  position: fixed;
  bottom: 20%;
  right: -65px;
  z-index: 100;
  img {
    width: 150px;
  }
}
.vc {
  ul {
    li {
      margin-left: 20px;
      list-style: disc;
    }
  }
  ol {
    li {
      margin-left: 23px;
      list-style: decimal;
    }
  }
  strong {
    font-weight: 700;
  }
}
.swiper-pagination {
  position: relative !important;
  margin-top: 20px;
}
.swiper-pagination-bullet-active {
  background-color: #47b372 !important;
}
</style>
